import { defineStore } from 'pinia'
import { useStore } from './index'

const defaultLocation = {
  display_name: '',
  area_name: '',
  area_line_number: 0,
  element_name: '',
  element_line_number: 0,
}

export const useImpressionStore = defineStore('impression', {
  state: () => ({
    location: defaultLocation,
  }),

  actions: {

    setLocation(location) {
      if (location) {
        this.location = location
      } else {
        this.location = {
          display_name: '',
          area_name: '',
          area_line_number: 0,
          element_name: '',
          element_line_number: 0,
        }
      }
    },

    clearLocation() {
      this.location = {
        display_name: '',
        area_name: '',
        area_line_number: 0,
        element_name: '',
        element_line_number: 0,
      }
    },

    async sendAppReadyImpression() {
      await IMPGET('active', {
        params: {
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendFlyerListImpression({ id, detailId, shopId, location }) {
      await IMPGET('flyer_list', {
        params: {
          id,
          detailId,
          shopId,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendContentListImpression({ id, location }) {
      await IMPGET('content_list', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendPricingListImpression({ id, location }) {
      await IMPGET('pricing_list', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendPercentListViewedImpression({ id, location }) {
      await IMPGET('percentoff_list', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendPercentDetailViewedImpression({ id, location }) {
      await IMPGET('percentoff_detail', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
      this.clearLocation()
    },

    async sendPercentDetailStartedReadingImpression({ id, location }) {
      await IMPGET('percentoff_read', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendPercentDetailFinishedReadingImpression({ id, location }) {
      await IMPGET('percentoff_read_complete', {
        params: {

          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendStampsheetListImpression({ id, location }) {
      await IMPGET('stampsheet_list', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMPp(),
        },
      })
    },

    async sendContentDetailFinishedReadingImpression({ id, location }) {
      await IMPGET('content_read_complete', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendPricingDetailFinishedReadingImpression({ id, location }) {
      await IMPGET('pricing_read_complete', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendContentDetailStartedReadingImpression({ id, location }) {
      await IMPGET('content_read', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendPricingDetailStartedReadingImpression({ id, location }) {
      await IMPGET('pricing_read', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendFlyerDetailViewedImpression({ id, detailId, shopId, location }) {
      await IMPGET('flyer_detail', {
        params: {
          id,
          detailId,
          shopId,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendContentDetailViewedImpression({ id, location }) {
      await IMPGET('content_detail', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendAsvQuestionnaireViewedImpression({ id, shopId, flyerlId, detailId, location, isFlyer}) {
      const flyerParams = {
        id,
        shopId,
        flyerlId,
        detailId,
        location: JSON.stringify(location),
        isFlyer,
        reqTime: UNIXTIMESTAMP(),
      }
      await IMPGET('adv_questionnaire_open', {
        params: flyerParams,
      })
    },

    // async sendAdvDetailFinishedReadingImpression({ id, shopId, flyerlId, detailId, location, isFlyer }) {
    //   const flyerParams = {
    //     id,
    //     shopId,
    //     flyerlId,
    //     detailId,
    //     location: JSON.stringify(location),
    //     reqTime: UNIXTIMESTAMP(),
    //   }
    //   await IMPGET('adv_read_complete', {
    //     params: flyerParams
    //   })
    // },

    async sendQuestionnaireViewedImpression( { id }) {
      await IMPGET('questionnaire_open', {
        params: {
          id,
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendPricingDetailViewedImpression({ id, location }) {
      await IMPGET('pricing_detail', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendMessageListImpression({ id, location }) {
      await IMPGET('message_list', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendStampsheetDetailStartedReadingImpression({ id, location }) {
      await IMPGET('stampsheet_read', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendStampsheetDetailFinishedReadingImpression({ id, location }) {
      await IMPGET('stampsheet_read_complete', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendStampsheetDetailViewedImpression({ id, location }) {
      await IMPGET('stampsheet_detail', {
        params: {
          id,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendThemeListImpression({ id, shopId, flyerlId, location }) {
      await IMPGET('theme_list', {
        params: {
          id,
          shopId,
          flyerlId,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendThemeDetailViewedImpression({ id, shopId, flyerlId, detailId, location }) {
      await IMPGET('theme_detail', {
        params: {
          id,
          shopId,
          flyerlId,
          detailId,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendProductListViewedImpression({ id, shopId, flyerlId, detailId, refId, flyerThemeId, location }) {
      await IMPGET('product_list', {
        params: {
          id,
          shopId,
          flyerlId,
          detailId,
          refId,
          flyerThemeId,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendProductDetailViewedImpression({ id, location, flyerThemeId, flyerId }) {
      await IMPGET('product_detail', {
        params: {
          id,
          flyerId,
          flyerThemeId,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendMakerListImpression({ id, shopId, flyerlId, location }) {
      await IMPGET('adv_list', {
        params: {
          id,
          shopId,
          flyerlId,
          location: JSON.stringify(location),
          reqTime: UNIXTIMESTAMP(),
        },
      })
    },

    async sendMakerDetailViewedImpression({ id, shopId, flyerlId, detailId, location, isFlyer }) {
      const flyerParams = {
        id,
        shopId,
        location: JSON.stringify(location),
        reqTime: UNIXTIMESTAMP(),
      }
      await IMPGET('adv_detail', {
        params: flyerParams
      })
    },

    async sendAdvDetailStartedReadingImpression({ id, shopId, flyerlId, detailId, location, isFlyer }) {
      const flyerParams = {
        id,
        shopId,
        location: JSON.stringify(location),
        reqTime: UNIXTIMESTAMP(),
      }
      await IMPGET('adv_read', {
        params: flyerParams
      })
    },

    async sendAdvDetailFinishedReadingImpression({ id, shopId, flyerlId, detailId, location, isFlyer }) {
      const flyerParams = {
        id,
        shopId,
        flyerlId,
        detailId,
        location: JSON.stringify(location),
        reqTime: UNIXTIMESTAMP(),
      }
      await IMPGET('adv_read_complete', {
        params: flyerParams
      })
    },

    async sendPVImpression({ id, shopId, flyerId, detailId, page }) {
      const rootStore = useStore()
      const params = {
        media: rootStore.mediaId,
        page: page ?? 'null',
        id: id ?? 'null',
        shopId: shopId ?? 'null',
        flyerId: flyerId ?? 'null',
        detailId: detailId ?? 'null',
        reqTime: UNIXTIMESTAMP(),
      }
      await IMPPV('/pv/pageview', {
        params: params
      })
      // console.log(params)
    },

  }
})
